import http from '@/util/http'

class InvitationAcceptApi {
  //邀请函接收 -- 分页查询
  getPageManaInviAppLy(params) {
    var url = '/share-foreign/invi/getPageManaInviAppLy';
    return http.post(url, params);
  }
  //邀请函接收 -- 分页查询
  getPageManaInviAppLyDept(params) {
    var url = '/share-foreign/invi/getPageManaInviAppLyDept';
    return http.post(url, params);
  }
  //邀请函接收 -- 接收
  receInviAppLy(params) {
    var url = '/share-foreign/invi/receInviAppLy';
    return http.post(url, params);
  }
  //邀请函接收 -- 退回
  rollbackInviAppLy(params) {
    var url = '/share-foreign/invi/rollbackInviAppLy';
    return http.post(url, params);
  }
  //邀请函管理 -- 操作日志
  getFeedbackList(params) {
    var url = '/share-foreign/invi/getFeedbackList';
    return http.post(url, params);
  }
  // 获取pdf列表
  getPDFList(params){
    let url = `/share-foreign/applyLetter/getFileList`;
    return http.post(url,params)
  }
  /**
   * 预览pdf
   *
   * @param {Object} params
   * @param {String} fileName - 文件名
   * @param {Number} type=[1|2] - 1为原始,2为拼接过签名的
   * @memberof InvitationAcceptApi
   */
  preview(params){
    let url = `/share-foreign/applyLetter/viewPdf`
    return http.get(url,params)
  }
  /**
   * 预览pdf
   *
   * @param {Object} params
   * @param {String} fileName - 文件名
   * @param {File} file - 文件
   * @memberof InvitationAcceptApi
   */
  upload(params){
    let url =`/share-foreign/applyLetter/uploadPdf`
    return http.post(url,params)
  }
  apply(params){
    let url = `/share-foreign/applyLetter/initiateApply`
    return http.post(url,params)
  }
  submitApproval(params){
    let url = `/share-foreign/approval/initApproval`
    return http.post(url,params)
  }
  getDialog(params){
    let url = `/share-foreign/approval/getApprovalLogs`
    return http.post(url,params)
  }
  dividePerson(params){
    let url = "/share-foreign/invi/groupPerson"
    return http.post(url,params)
  }
  getStatus(){
    let url = "/share-foreign/invi/getInviStatus"
    return http.post(url,{})
  }
}

export default InvitationAcceptApi
